import { render } from "./market-create.vue?vue&type=template&id=178f28fb&scoped=true"
import script from "./market-create.vue?vue&type=script&lang=js"
export * from "./market-create.vue?vue&type=script&lang=js"

import "./market-create.vue?vue&type=style&index=0&id=178f28fb&lang=scss&scoped=true"
import "./market-create.vue?vue&type=style&index=1&id=178f28fb&lang=scss"

import exportComponent from "/data/jenkins/workspace/talk-community-h5-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-178f28fb"]])

export default __exports__